module.exports = __webpack_public_path__ + "img/boating.15335f5a.svg";